import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { HostListener } from '@angular/core';
import { AddfinetypepopupComponent } from '../../generalpopup/addfinetypepopup/addfinetypepopup.component';
import { TranspaymentinfoComponent } from '../../grid/transpaymentinfo/transpaymentinfo.component';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
@Component({
  selector: 'app-addfine',
  templateUrl: './addfine.component.html',
  styleUrls: ['./addfine.component.css']
})
export class AddfineComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "Fine";
  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;
  ispaymentmode: boolean = false;


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isfinetypeaddmode: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;

  ismanualclose: boolean;

  isemploading: boolean = false;
  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filterfinetypeid: any = null;
  filterfinetypename: any = null;
  filterpaymentstatus: string = "";
  filtermemoid: number = 0;
  filtermemoempid: number = 0;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  //Edit Get Values
  fineColl: any = [];
  fineid: number = 0
  fineBO: any = {}



  finetypeColl: any = [];
  empColl: any = [];
  empBO: any = {}

  fineform = new FormGroup({
    fineid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    finetypeid: new FormControl(null, Validators.required),
    amount: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    inactive: new FormControl(false),
    isaffectpayroll: new FormControl(false),
    effectivedt: new FormControl(null, Validators.required),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.fineid = params.id
      }

      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }

    });
    this.fnGetParameterVariable();
    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
      if (params.finetypeid !== undefined) {
        this.filterfinetypeid = params.finetypeid
      }

      if (params.finetypename !== undefined) {
        this.filterfinetypename = params.finetypename
      }
      if (params.paymentstatus !== undefined) {
        this.filterpaymentstatus = params.paymentstatus
      }
      if (params.memoid !== undefined) {
        this.filtermemoid = params.memoid
      }
      if (params.memoempid !== undefined) {
        this.filtermemoempid = params.memoempid
      }

    })
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.fineform.reset();
      this.fnInitializeFormGroup();

      if (this.fineid > 0) {
        this.fngetFine();
      }
      this.fngetFinetype();
      this.fngetEmployee();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.fineid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')
    this.ispaymentmode = this.loginService.fnCheckUserRoleAction(this.formname, 'PAYMENT')
    this.isfinetypeaddmode = this.loginService.fnCheckUserRoleAction("FineType", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.fineform.setValue({
      fineid: 0,
      empid: null,
      finetypeid: null,
      amount: null,
      transdt: new Date(),
      descr: '',
      inactive: false,
      isaffectpayroll: false,
      effectivedt: this.loginService.fnLastDate(new Date()),
    })

    if (this.filtermemoempid > 0) {
      this.fineform.patchValue({ empid: Number(this.filtermemoempid) })

    }
  }

  fngetFinetype() {
    var data = {
      'finetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getFineType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.finetypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetEmployee() {
    this.isemploading = true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading = false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading = false;
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetFine() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'fineid': this.fineid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getFine(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.fineColl = res.json().result;
            var editdata = this.fineColl[0];
            this.fineBO = editdata;
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.fineform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }
  }

  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      if (this.loginService.fnCheckFornControlNotfound(this.fineform.get('effectivedt'))) {
        this.fineform.controls['effectivedt'].setErrors(null);
      }


      //Validate
      if (this.fineform.valid) {
        if (this.loginService.fnCompareDateValidation(this.fineform.get('effectivedt').value, this.fineform.get('transdt').value)) {
          this.fineform.controls['effectivedt'].setErrors({ 'notfound': true });
          return
        }

        this.saveloading = true;


        //Check
        var data = {
          'fineid': this.fineid,
          'memoid': this.filtermemoid,
          'transdt': this.fnFormatDatetime(this.fineform.get('transdt').value),
          'effectivedt': this.fnFormatDatetime(this.fineform.get('effectivedt').value),
          'empid': this.fineform.get('empid').value,
          'finetypeid': this.fineform.get('finetypeid').value,
          'amount': this.fineform.get('amount').value,
          'descr': this.fineform.get('descr').value,
          //'effectivedt':this.fnFormatDatetime(this.fineform.get('effectivedt').value),                  
          'inactive': this.fineform.get('inactive').value,
          'isaffectpayroll': this.fineform.get('isaffectpayroll').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }



        if (this.fineform.get('fineid').value > 0) {
          //Update 
          this.fnSetFine(data);
        }
        else {
          //Insert 
          this.fnInsertFine(data);
        }


      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertFine(data) {

    this.appService.fnInsertFine(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The new fine has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].fineid);
            }

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetFine(data) {

    this.appService.fnSetFine(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The Fine has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.fineid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.fineid);
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }


  //AddfineType
  private fnAddFineType() {

    const modalRef = this.productFindService.open(AddfinetypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetFinetype();

      if (receivedEntry > 0) {
        this.fineform.patchValue({ finetypeid: receivedEntry })
      }
    });

  }
  fnAddPaymentInfo() {

    const modalRef = this.productFindService.open(TranspaymentinfoComponent, { size: <any>'l' });
    modalRef.componentInstance.trid = this.fineid;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.transdate = this.fineBO.transdt;
    modalRef.componentInstance.transpaymodeid = this.fineBO.transpaymodeid;
    modalRef.componentInstance.refno = this.fineBO.payrefno;
    modalRef.componentInstance.paiddt = this.fnConvertDatetime(this.fnFormatDatetime(this.fineBO.paiddt));
    modalRef.componentInstance.paymentinfo = this.fineBO.paymentinfo;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "DONE") {
        this.fngetFine();
      }
    });
  }
  public fnRemovePayment() {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to Remove Payment?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnSetRemovePayment()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  private fnSetRemovePayment() {
    var data = {
      'trxid': this.fineid,
      'formname': this.formname,
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    this.appService.fnSetRemovePayment(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.toastr.success('', " The Payment has been Removed successfully.");
            //this.fnInsertActivityLog('DELETE', deptid, reftxt);
            this.fngetFine();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnEditFormEdit(id) {

    this.fineid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'finetypeid': this.filterfinetypeid,
      'finetypename': this.filterfinetypename,
      'paymentstatus': this.filterpaymentstatus,
    }



    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });

  }

  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
            'finetypeid': this.filterfinetypeid,
            'finetypename': this.filterfinetypename,
            'paymentstatus': this.filterpaymentstatus,

          }
        }

        this.router.navigate(['/Fine'], navigationExtras);
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.effectivedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivedt));

    this.fineform.setValue({
      fineid: deptBO.fineid,
      empid: deptBO.empid,
      finetypeid: deptBO.finetypeid,
      amount: deptBO.amount,
      transdt: deptBO.transdt,
      descr: deptBO.descr,
      effectivedt: deptBO.effectivedt,
      inactive: deptBO.inactive,
      isaffectpayroll: deptBO.isaffectpayroll,
    });

    this.formmode = "Edit";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();
    this.fnChangeEmpLookup();
    this.fnGetAttachmentCount();
  }


  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetFine();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.fineBO.approvedstatus !== '') {
      if (this.fineBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.fineBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.fineid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();

    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetFine();
      }
    });


  }


  fnAttachmentSave(tid) {



  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }





  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.fineid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetFine();
      }


    });
  }



  //Attachment
  fnGetAttachmentCount() {
    if (this.fineid > 0) {
      var data = {
        'trxid': this.fineid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }

  fnAddActivity() {

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.fineid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }

  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
